const head = document.querySelector(`head`)

const STYLE_NODE = 'STYLE'
const LINK_NODE = 'LINK'

const observerConfig = {
  attributes: true,
  childList: true,
  characterData: true,
}

/**
 * Added a mutation observer to detect when a <style> tag is added the in order to always add shell's style as the last style applied.
 * This is to make sure that the shell's styles are not overwritten by an experience styles
 */
export const keepShellStyleSheetsLastInNodeList = () => {
  const observer = new MutationObserver(mutations => {
    let shouldRearrangeStyles = false
    const chameleonStyleSheets = Array.from(head?.querySelectorAll('#chameleon-theme-skin-style')?.values() ?? [])
    const shellStyleSheets = Array.from(head?.querySelectorAll('#shell-main-css')?.values() ?? [])

    shouldRearrangeStyles = mutations.some(mutation => {
      const addedNodes = Array.from(mutation.addedNodes)
      return addedNodes.some(node => {
        const isNodeStyleOrLink = node.nodeName === STYLE_NODE || node.nodeName === LINK_NODE
        const isNodeInShellStylesArray = isNodeinStyleArray(node, shellStyleSheets)
        const isNodeInChameleonStylesArray = isNodeinStyleArray(node, chameleonStyleSheets)

        return isNodeStyleOrLink && !isNodeInShellStylesArray && !isNodeInChameleonStylesArray
      })
    })
    if (shouldRearrangeStyles) {
      // Append chameleon styles first, maintaining their order
      chameleonStyleSheets.forEach(styleSheet => head?.appendChild(styleSheet))
      // Then append shell styles
      shellStyleSheets.forEach(styleSheet => head?.appendChild(styleSheet))

      shouldRearrangeStyles = false
    }
  })

  if (head) {
    observer.observe(head, observerConfig)
  }
}

const isNodeinStyleArray = (node: Node, styleElementArray: Element[]) =>
  styleElementArray.some(styleElement => node === styleElement)
